import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Modal, Form, Space, Button, message } from "antd";

//components
import ServiceName from "./component/service_name";
import ServiceRegularPrice from "./component/service_regular_price";
import ServiceSpecialPrice from "./component/service_special_price";
import ServiceDescription from "./component/service_descriptions";
import ServiceSelectGroup from "./component/service_select_group";
//redux
import { useDispatch, useSelector } from "react-redux";
import { setOpenDetailService } from "../../../store/var/var.action";
import { openEditService } from "../../../store/var/var.selector";
import { selectedDetailService } from "../../../store/var/var.selector";
import { updateService } from "../../../store/service/service.action";
// import { detailSelector } from "../../../store/branch/branch.selector";

const DialogServiceDetail = () => {
  // -------------------------- VAR --------------------------

  const [form] = Form.useForm();

  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(openEditService);
  const selected = useSelector(selectedDetailService);
  const nameService = selected?.name;
  const title = (
    <span>
      Edit service: "<strong>{nameService}</strong>"
    </span>
  );
  // -------------------------- FUNCTION --------------------------
  const closeDialogDetail = () => {
    dispatch(setOpenDetailService({ data: false }));
  };

  const onFinish = (values) => {
    if (values && selected) {
      console.log({ values });
      setLoading(true);
      dispatch(
        updateService({ update: values, detail: selected }, (res) => {
          setLoading(false);
          if (res.status === 200) {
            message.success("Added Service Succesfully!.");
            closeDialogDetail();
          } else {
            message.error(res.data);
          }
        })
      );
    }
  };

  const onFinishFailed = (err) => {
    console.log({ err });
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (selected) {
      form.setFieldsValue(selected);
    }
  }, [form, selected]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 0]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ServiceName />
        </Col>
        <Col xl={12} lg={12} md={24} xs={24}>
          <ServiceRegularPrice />
        </Col>
        <Col xl={12} lg={12} md={24} xs={24}>
          <ServiceSpecialPrice />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ServiceDescription />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ServiceSelectGroup />
        </Col>
      </Row>
    );
  };

  const renderFooter = () => {
    return (
      <Space>
        <Button type="default" onClick={closeDialogDetail}>
          Cancel
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          form="update-service"
          loading={loading}
        >
          Update
        </Button>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title={title}
      open={open}
      onCancel={closeDialogDetail}
      footer={renderFooter()}
    >
      <Form
        id="update-service"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
      >
        {renderBody()}
      </Form>
    </Modal>
  );
};

export default DialogServiceDetail;
